import { render, staticRenderFns } from "./UserEditApp.vue?vue&type=template&id=6f5c737a"
import script from "./UserEditApp.vue?vue&type=script&lang=js"
export * from "./UserEditApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports